/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { TAvailabilities, TAvailability, TOrderArray, TStoreAvailabilities, TStoreAvailability } from "./types";
import AvailabilityCompactView from "./compactView";
import AvailabilityFullView from "./fullView";

import _ from 'lodash';

import './styles.scss';
import { bucketParser, getDeliveredDay, getStoreAddress } from "./functions";
import moment from "moment";
import { useTypedSelector } from "store/store";

type IProps = {
  availabilites: TAvailabilities;
  isFullView: boolean;
  showFullList?: boolean;
  showTooltip?: boolean;
  orderArray?: TOrderArray;
}

const Availability = (props: IProps) => {

  // Props
  const { availabilites, isFullView = false, showFullList = false, showTooltip = true, orderArray } = props;

  // Redux states
  const mygarage = useTypedSelector(state => state.mygarage);
  const stores = mygarage.storeList;

  // Local States
  const [avails, setAvails] = useState<TStoreAvailabilities | []>([]);

  const prepareAvailabilities = (availabilites: TAvailabilities) => {
    const storeAvailabilities: TStoreAvailabilities = availabilites?.flatMap((a: TAvailability) => a.storeAvailabilities.map(sa => {
      if (sa.validForMin) {
        return ({ ...sa, deliveryDay: getDeliveredDay(sa), bucket: bucketParser(a.availableDuration), moment: moment().add(sa.validForMin > 0 ? sa.validForMin : 0, 'minutes'), address: getStoreAddress(sa.store, stores) })
      } else {
        return ({ ...sa, storeQty: sa.storeQty, deliveryDay: getDeliveredDay(sa), bucket: bucketParser(a.availableDuration), moment: moment().add(sa.validForMin > 0 ? sa.validForMin : 0, 'minutes'), address: getStoreAddress(sa.store, stores) })
      }
    }
    )) || [];

    const grouped: TStoreAvailabilities = [];
    _.sortBy(storeAvailabilities, ['displaySeq']).forEach((s: TStoreAvailability) => {
      if (s.validForMin) {

        const _store = grouped.find((g: TStoreAvailability) => g.storeTime === s.storeTime && g.bucket === s.bucket && g.validForMin > 0 && g.validForMin === s.validForMin);

        if (_store) {
          _store.stores.push({ store: s.store, storeQty: s.storeQty, address: getStoreAddress(s.store, stores) });
          _store.storeQty = _store.storeQty + s.storeQty;
          _store.address = getStoreAddress(s.store, stores);
        } else {
          grouped.push({ ...s, stores: [{ store: s.store, storeQty: s.storeQty, address: getStoreAddress(s.store, stores) }] });
        }
      } else {
        const _store = grouped.find((g: TStoreAvailability) => g.bucket === s.bucket);
        if (_store) {
          _store.stores.push({ store: s.store, storeQty: s.storeQty, address: getStoreAddress(s.store, stores) });
          _store.storeQty = _store.storeQty + s.storeQty;
          _store.address = getStoreAddress(s.store, stores);
        } else {
          grouped.push({ ...s, stores: [{ store: s.store, storeQty: s.storeQty, address: getStoreAddress(s.store, stores) }] });
        }
      }
    });

    const sorted = _.orderBy(grouped, ['displaySeq']);
    console.log('sorted with address: ', sorted);

    setAvails(sorted);
  }

  useEffect(() => {
    prepareAvailabilities(availabilites);
  }, [availabilites]);

  return <React.Fragment>
    {isFullView ? <AvailabilityFullView orderArray={orderArray || []} avails={avails} /> : <AvailabilityCompactView avails={avails} showFullList={showFullList} showTooltip={showTooltip} />}
  </React.Fragment>
}

export default Availability;
